<div class="inner-page-header">
  <h3>{{ title }}</h3>
</div>
<form
  class="needs-validation"
  id="general-form"
  [formGroup]="projectFormGroup"
>
  <div class="main-card">
    <div class="row">
      <div class="flex-wrapper">
        <div class="client-deliver flex-child">
          @if (contractAcquiringUnitUrl) {
          <div>
            <button
              type="button"
              class="btn btn-yellow"
              (click)="copyReportLink()"
            >
              <img src="assets/images/svg/copy-report-link.svg" alt="" />
              <span>نسخ الرابط تسليم الوحدة</span>
            </button>
          </div>
          }
          
        </div>
        <div class="project-link">
          <a (click)="goToOrders()">الطلبات المتعلقه بالعقد</a>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"> اسم العقد </label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            placeholder="يرجى كتابة اسم العقد"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"> تابع لشركة</label>
          <ng-select
            #selectcomp
            bindLabel="name_arabic"
            (scrollToEnd)="onScrollPagination()"
            class="single-select"
            formControlName="company"
            placeholder="يرجى كتابة اسم الشركة"
            [searchable]="true"
            (removed)="resetSearch()"
            (search)="searchText()"
            (clear)="resetSearch()"
            (open)="resetSearch()"
            [virtualScroll]="true"
            [clearable]="true"
          >
            @for (company of companies; track company) {
            <ng-option [value]="company.pk">
              {{ company.name_arabic }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">
            المشروع
            <span class="optional">(اختياري)</span>
          </label>
          <ng-select
            #selectreproject
            bindLabel="name_ar"
            (scrollToEnd)="onScrollREProjectPagination()"
            class="single-select"
            formControlName="project"
            placeholder="يرجى اختيار المشروع"
            [searchable]="true"
            (removed)="resetREProjectSearch()"
            (search)="searchREProjectText()"
            (clear)="resetREProjectSearch()"
            (open)="resetREProjectSearch()"
            [virtualScroll]="true"
            [clearable]="true"
          >
            @for (reProject of reProjects; track reProject) {
            <ng-option [value]="reProject.id">
              {{ reProject.name_ar }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">
            كود المشروع
            <span class="optional">(اختياري)</span>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="shortcode"
            placeholder="يرجى كتابة كود العقد"
          />
        </div>
      </div>
      <div class="col-md-6 switch-btn__wrapper">
        <app-switch-input
          [label]="'إظهار الشروط والأحكام في التقرير PDF'"
          [labelEn]="'show_terms_conditions'"
          [index]="'show_terms_conditions'"
          [value]="projectFormGroup.controls['show_terms_conditions'].value"
          (valueChanged)="clientStatus($event)"
        >
        </app-switch-input>
        <app-switch-input
          [label]="'إظهار وثائق العقار في التقرير'"
          [labelEn]="'show_order_documents'"
          [index]="'show_order_documents'"
          [value]="projectFormGroup.controls['show_order_documents'].value"
          (valueChanged)="clientStatus($event)"
        >
        </app-switch-input>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">
            عدد الوحدات
            <span class="optional">(اختياري)</span>
          </label>
          <input
            type="number"
            class="form-control"
            formControlName="units_count"
            placeholder="يرجى كتابة عدد الوحدات"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">تاريخ إعتماد العقد</label>
          <mat-form-field (click)="picker.open()" appearance="outline">
            <input
              matInput
              formControlName="active_date"
              [matDatepicker]="picker"
              disabled
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon class="calender-icon">
                <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">تاريخ تسليم العملاء</label>
          <mat-form-field (click)="picker_end.open()">
            <input
              matInput
              formControlName="expiry_date"
              [matDatepicker]="picker_end"
              disabled
            />
            <mat-datepicker-toggle matSuffix [for]="picker_end">
              <mat-icon matDatepickerToggleIcon class="calender-icon">
                <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker_end disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label file-label">
            ملف العقد
            <span class="optional">(اختياري)</span>
          </label>
          @if (fileName) {
          <div class="existance-wrapper">
            <div class="existance">
              <img src="assets/images/svg/file-name-icon.svg" alt="" />
              <span>{{ sliceFileName(fileName) }}</span>
            </div>
            <div>
              <button class="btn delete-wrapper" (click)="deleteFile()">
                <img src="assets/images/svg/DELETE1.svg" alt="" />
              </button>
            </div>
          </div>
          } @if (!fileName) {
          <div class="drag-btn">
            <button
              type="button"
              class="btn btn-outline-secondary add-new-file"
            >
              <img src="assets/images/svg/upload-img.svg" alt="" />
              رفع ملف
            </button>
            <input
              type="file"
              name=""
              (change)="handleFileInput($event.target.files)"
              accept="application/pdf"
              class="file-new form-control"
            />
            @if (fileSizeErr) {
            <div class="file-error">
              <span
                >عفوا لا يمكن رفع صور حجم اكبر من
                {{ MAX_FILE_SIZE / 1000000 }} GB
              </span>
            </div>
            }
          </div>
          }
        </div>
      </div>
      <div class="col-md-6 custom-control">
        <div class="form-group">
          <label for="" class="form-label"> خدمات العقد</label>
          <app-select
            [optionItems]="services"
            [placeholder]="'يرجى تحديد خدمات العقد'"
            [id]="'services'"
            [bindValue]="'pk'"
            [initValues]="initServices"
            (selectedOptions)="setServices($event)"
          >
          </app-select>
        </div>
      </div>
      <div class="col-md-6 custom-control">
        <div class="form-group">
          <label for="" class="form-label"> خدمات البنود</label>
          <app-select
            [optionItems]="dynamicServicesArr"
            [placeholder]="'يرجى تحديد خدمات البنود'"
            [id]="'dynamic_services'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [dynamicServicesItems]="dynamicServicesItemsData"
            [initValues]="initDynamicServices"
            (selectedOptions)="setDynamicServices($event)"
            (onScrollValues)="onScrollOptions($event)"
            (updateOptions)="updateDynamicServices($event)"
            (openSelect)="getDynamicServices()"
          >
          </app-select>
        </div>
      </div>
      <div class="col-md-6 custom-control">
        <div class="form-group">
          <label for="" class="form-label">
            إضافة فاحصين للمشروع
            <span class="optional">(اختياري)</span>
          </label>
          <app-select
            [optionItems]="inspectors"
            [id]="'inspector'"
            [placeholder]="'إضافة فاحصين للمشروع'"
            [bindLabel]="'full_name'"
            [bindValue]="'id'"
            [initValues]="initInspectors"
            (selectedOptions)="setInspectors($event)"
            (onScrollValues)="onScrollInspectorOptions($event)"
            (updateOptions)="updateInspectors($event)"
          >
          </app-select>
        </div>
      </div>
      <div class="col-md-6 custom-control">
        <label for="" class="form-label">
          حالة العقد </label>
        <ng-select bindLabel="name" class="single-select" placeholder="اختر" appendTo="body"
          formControlName="project_status" [searchable]="true" [clearable]="true">
          @for (type of projectStatusList; track type) {
          <ng-option [value]="type.id">
            {{ type.name }}
          </ng-option>
          }
        </ng-select>
      </div>

      <div class="col-md-6">
        <app-assets-uploader
          [isFile]="isFileMap['project_banner']"
          [title]="'لافتة'"
          (fileNameChange)="fileNameChange($event)"
          [field]="'project_banner'"
          [projectAssets]="projectAssets.banner"
          [MAX_File_SIZE]="3000000"
          [formGroup]="projectFormGroup"
        ></app-assets-uploader>
      </div>

      <div class="col-md-6">
        <app-assets-uploader
          [isFile]="isFileMap['project_image']"
          [title]="'صورة العقد'"
          [field]="'project_image'"
          (fileNameChange)="fileNameChange($event)"
          [projectAssets]="projectAssets.image"
          [MAX_File_SIZE]="3000000"
          [formGroup]="projectFormGroup"
        ></app-assets-uploader>
      </div>

      <div class="col-md-6">
        <label class="form-label">وصف العقد </label>
        <textarea class="form-control custom-text-area" name="description" id="description" formControlName="description"></textarea>
      </div>

    </div>
    
    @if (alertmsg) {
    <div class="alert-box">
      <img
        src="assets/images/svg/error-icon.svg"
        class="close-alert"
        (click)="closeError()"
        alt=""
      />
      <p class="alert-msg">{{ message }}</p>
    </div>
    }

    <div class="row">
      <div class="col-md-12 single-action">
        <app-action-button [label]="saveBtn" (submitAction)="save(true, $event)"></app-action-button>
      </div>
    </div>

  </div>
@if (projectID){
<div class="main-card services-wrapper">
  <div class="inner-title">
    <h3> التصور الزمني للعقد </h3>
  </div>
  <div class="row border-top border-bottom p-3">
    <div class="col-md-12">
      <div class="form-group mb-0">
        <label for="" class="form-label">تاريخ بداية العقد</label>
        <input
        type="text"
        class="form-control"
        [value]="projectFormGroup.controls['active_date'].value | date: 'yyyy-MM-dd'"
        placeholder="يرجى كتابة تاريخ بداية العقد"
        readonly>
      </div>
    </div>
  </div>

  <div class="row p-3" formArrayName="service_timeline_data"> 
    @for (service of serviceTimelineArray.controls; track service.value.service; let i = $index) {
    <div  [formGroupName]="i"  class="col-md-4">
      <label for="" class="form-label"> اسم الخدمة </label>
      <input  
        type="text"
        class="form-control"
        formControlName="name"
        placeholder="يرجى كتابة اسم الخدمة"
        readonly
      />
    </div>
    <div class="col-md-4" [formGroupName]="i" >
      <div class="form-group">
        <label for="" class="form-label">تاريخ المتوقع لبداية فحص الخدمة</label>
        <mat-form-field (click)="picker.open()" appearance="outline">
          <input
            matInput
            formControlName="expected_start_date"
            [min]="projectData?.active_date"
            [max]="projectData?.expiry_date"
            [matDatepicker]="startpicker"
            disabled
            readonly
            (click)="preventPickerOpen($event)"
          />
          <mat-datepicker-toggle matSuffix [for]="startpicker">
            <mat-icon matDatepickerToggleIcon class="calender-icon">
              <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #startpicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-4" [formGroupName]="i">
      <div class="form-group">
        <label for="" class="form-label">تاريخ المتوقع لنهاية فحص الخدمة</label>
        <mat-form-field (click)="picker.open()" appearance="outline">
          <input
            matInput
            formControlName="expected_delivery_date"
            [min]="projectData?.active_date"
            [max]="projectData?.expiry_date"
            [matDatepicker]="endpicker"
            disabled
            readonly
            (click)="preventPickerOpen($event)"
          />
          <mat-datepicker-toggle matSuffix [for]="endpicker">
            <mat-icon matDatepickerToggleIcon class="calender-icon">
              <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #endpicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    }
  </div>

    <div class="row border-top p-3">
      <div class="col-md-12">
        <div class="form-group mb-0">
          <label for="" class="form-label">تاريخ نهاية العقد</label>
          <input
          type="text"
          class="form-control"
          [value]="projectFormGroup.controls['expiry_date'].value | date: 'yyyy-MM-dd'"
          readonly>
        </div>
      </div>
    </div>
    
    <div class="row border-top">
      <div class="col-md-12 single-action mt-3">
        <app-action-button [label]="saveBtn" (submitAction)="saveTimeline($event)"></app-action-button>
      </div>
    </div>
</div>
}

</form>
